export const checkWindow = (maxWidthPixel) =>
    typeof window !== "undefined" &&
    window.matchMedia(`(max-width: ${maxWidthPixel}px)`).matches;

export const isPad = checkWindow(1024)
export const isTabled = checkWindow(768)
export const isMobile = checkWindow(600)

export const windowResize = (setMathSize, width) => {
    window.addEventListener("resize", () => {
        setMathSize(checkWindow(width));
        return window.removeEventListener("resize", () =>
            setMathSize(checkWindow(width))
        );
    });
};
